

import * as THREE from "three";
import { PointerLockControls } from "three/examples/jsm/controls/PointerLockControls.js";
import {DefaultDeviceHandler} from "./default_device_handler";

export class ThreeMinecraftHandler extends DefaultDeviceHandler {

	sendTimer = 200;

	raycaster = null;

	cameraOffset = {x: 0, y: 0, z: 0};

	lastSendTime = 0;
	lastSentTarget = new THREE.Vector3(0, 0, 0);

	constructor(demo) {
		super("MINECRAFT");
		this.demo = demo
		this.raycaster = new THREE.Raycaster();
		this.objects = [];
		this.renderer = null;
		this.prevTime = performance.now();

		this.canJump = false;
		this.moveForward = false;
		this.moveLeft = false;
		this.moveBackward = false;
		this.moveRight = false;

		this.velocity = new THREE.Vector3()
		this.direction = new THREE.Vector3()
		this.vertex = new THREE.Vector3()

		this.setupListeners();
	}

	setupListeners() {
		document.addEventListener('keydown', (e) => this.onKeyDown(e));
		document.addEventListener('keyup', (e) => this.onKeyUp(e));
	}

	onKeyDown(event) {
		// console.log('testing::event', event)

		switch ( event.code ) {
			case 'ArrowUp':
			case 'KeyW':
				this.moveForward = true;
				break;

			case 'ArrowLeft':
			case 'KeyA':
				this.moveLeft = true;
				break;

			case 'ArrowDown':
			case 'KeyS':
				this.moveBackward = true;
				break;

			case 'ArrowRight':
			case 'KeyD':
				this.moveRight = true;
				break;

			case 'Space':
				if (this.canJump === true) this.velocity.y += 350;
				this.canJump = false;
				break;
		}
	};

	onKeyUp(event) {
		switch ( event.code ) {
			case 'ArrowUp':
			case 'KeyW':
				this.moveForward = false;
				break;

			case 'ArrowLeft':
			case 'KeyA':
				this.moveLeft = false;
				break;

			case 'ArrowDown':
			case 'KeyS':
				this.moveBackward = false;
				break;

			case 'ArrowRight':
			case 'KeyD':
				this.moveRight = false;
				break;
		}
	};

	animate(delta, onChange) {

		const time = performance.now()

		if ( this.deviceControls.isLocked === true ) {
			const delta = ( time - this.prevTime ) / 1000;

			this.velocity.x -= this.velocity.x * 10.0 * delta;
			this.velocity.z -= this.velocity.z * 10.0 * delta;

			this.velocity.y -= 9.8 * 100.0 * delta; // 100.0 = mass

			this.direction.z = Number( this.moveForward ) - Number( this.moveBackward );
			this.direction.x = Number( this.moveRight ) - Number( this.moveLeft );
			this.direction.normalize(); // this ensures consistent movements in all directions

			if ( this.moveForward || this.moveBackward ) this.velocity.z -= this.direction.z * 400.0 * delta;
			if ( this.moveLeft || this.moveRight ) this.velocity.x -= this.direction.x * 400.0 * delta;

			this.deviceControls.moveRight( - this.velocity.x * delta );
			this.deviceControls.moveForward( - this.velocity.z * delta );

			this.deviceControls.getObject().position.y += ( this.velocity.y * delta ); // new behavior

			if ( this.deviceControls.getObject().position.y < 3 ) {

				this.velocity.y = 0;
				this.deviceControls.getObject().position.y = 3;

				this.canJump = true;

			}

		}

		this.prevTime = time

		// this.renderer.render(scene, camera)

	}

	showInstructions = () => {
		instructions.style.display = 'none';
		this.demo.deactivateListeners = false
	}

	hideInstructions = () => {
		instructions.style.display = 'flex';
		this.demo.deactivateListeners = true
	}

	lockToWindow = () => {
		this.deviceControls.lock();
	}

	removeListeners() {
		this.deviceControls.removeEventListener( 'lock', this.showInstructions);

		this.deviceControls.removeEventListener( 'unlock', this.hideInstructions);

		const instructions = document.getElementById('instructions')
		instructions.removeEventListener('click', this.lockToWindow)
		instructions.style.display = 'none';
	}

	bindControls(camera, renderer, scene) {
		this.renderer = renderer
		this.scene
		camera.rotateX(Math.PI / 180);
		const cpos = camera.position.clone()

		this.deviceControls = new PointerLockControls(camera, document.body);
		// this.deviceControls.target.set(cpos.x, cpos.y, cpos.z +1)
		// TODO: check here
		this.raycaster = new THREE.Raycaster( new THREE.Vector3(), new THREE.Vector3( 0, - 1, 0 ), 0, 10 );
		this.deviceControls.lock()

		const instructions = document.getElementById('instructions')
		instructions.style.display = 'flex';

		instructions.addEventListener('click', this.lockToWindow)

		this.deviceControls.addEventListener( 'lock', this.showInstructions);

		this.deviceControls.addEventListener( 'unlock', this.hideInstructions);

		this.deviceControls.panSpeed = 6;
		this.deviceControls.minDistance = 15
		this.deviceControls.maxDistance = 15;

		this.deviceControls.minDistance = 0;

		this.deviceControls.getObject().lookAt(0,0,0)

		return this.deviceControls;
	}

	isFreeFly() {
		return true;
	}

	getPosition() {
		if (this.target === null)
			return null;

		return this.target.clone()
	}

	getRotation() {
		return 0
	}

	getAngle() {
		return 0
	}
}
